// /account/register?email=domingovolkman%40example.com&given_name=Wilbert&family_name=Batz

export default class RegisterForm extends HTMLElement {
  constructor() {
    super();

    if (!this.searchParams.size) return;

    this.prepopulateInputs();
  }

  get searchParams() {
    return new URLSearchParams(location.search);
  }

  get emailInput() {
    return this.querySelector("[type='email']");
  }

  get givenNameInput() {
    return this.querySelector("[autocomplete='given-name']");
  }

  get familyNameInput() {
    return this.querySelector("[autocomplete='family-name']");
  }

  get passwordInput() {
    return this.querySelector("[type='password']");
  }

  prepopulateInputs() {
    this.populateEmail();
    this.populateGivenName();
    this.populateFamilyName();

    if (this.emailInput.value) {
      this.passwordInput?.focus();
    }
  }

  populateEmail() {
    if (!this.searchParams.has("email") || !this.emailInput) return;
    const value = this.searchParams.get("email");
    this.emailInput.value = value;
  }

  populateGivenName() {
    if (!this.searchParams.has("given_name") || !this.givenNameInput) return;
    const value = this.searchParams.get("given_name");
    this.givenNameInput.value = value;
  }

  populateFamilyName() {
    if (!this.searchParams.has("family_name") || !this.familyNameInput) return;
    const value = this.searchParams.get("family_name");
    this.familyNameInput.value = value;
  }
}
